// react
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
// api
import { GetPublicTitleDetailsBlocksAndLocationsDto } from "../../../../../api/Client";
// me
import BlocksView from "./BlocksView";
import LocationsView from "./LocationsView";

interface IProps {
    blocksAndLocations: GetPublicTitleDetailsBlocksAndLocationsDto | undefined;
    isLocationsDataVisible: boolean;
    areaSqKm: number | undefined;
}

export default function BlocksAndLocationsView(props: IProps) {
    const { blocksAndLocations, isLocationsDataVisible, areaSqKm } = props;
    const blocks = blocksAndLocations?.blocks ?? [];
    const locations = blocksAndLocations?.locations ?? [];

    return (
        <>
            <div className="mt-2">
                <Tabs defaultActiveKey="blocks">
                    {/* Blocks Tab */}
                    <Tab eventKey="blocks" title="Title Blocks">
                        <BlocksView blocks={blocks} showLocationName={isLocationsDataVisible} areaSqKm={areaSqKm} />
                    </Tab>

                    {/* Locations Tab */}
                    {isLocationsDataVisible && (
                        <Tab eventKey="locations" title="Locations">
                            <LocationsView locations={locations} />
                        </Tab>
                    )}
                </Tabs>
            </div>
        </>
    );
}
